import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';

import {GroupsApi} from '@core/backend/engin/api/demo/groups.api';
import {
    FunctionalUnitAsset,
    FailureMode,
    FunctionalUnit,
    AssetGroup,
    GroupContext,
    GroupsService,
    ReliabilityBlockDiagram,
} from '@core/interfaces/engin/demo/groups';
import {APIResponse} from '@core/interfaces/system/system-common';
import {map, tap} from 'rxjs/operators';
import {DataSource} from '@mominsamir/ngx-smart-table/lib/lib/data-source/data-source';

@Injectable()
export class GroupsServiceImpl extends GroupsService {
    constructor(private api: GroupsApi) {
        super();
    }

    searchGroups(workflowItemId: number, searchString: string): Observable<AssetGroup[]> {
        return this.api
            .searchGroups(workflowItemId, searchString)
            .pipe(map((resp: APIResponse<AssetGroup[]>) => resp.response));
    }

    getGroupContext(workflowItemId: number, groupId: string): Observable<GroupContext> {
        return this.api
            .getGroupContext(workflowItemId, groupId)
            .pipe(map((resp: APIResponse<GroupContext>) => resp.response));
    }

    getGroupAssets(workflowItemId: number, groupId: string): Observable<FunctionalUnit[]> {
        return this.api
            .getGroupAssets(workflowItemId, groupId)
            .pipe(map((resp: APIResponse<FunctionalUnit[]>) => resp.response));
    }

    getFunctionalUnitAssets(
        workflowItemId: number,
        groupId: string,
        functionalUnitId: string,
    ): Observable<FunctionalUnitAsset[]> {
        return this.api
            .getFunctionalUnitAssets(workflowItemId, groupId, functionalUnitId)
            .pipe(map((resp: APIResponse<FunctionalUnitAsset[]>) => resp.response));
    }

    getReliabilityBlockDiagram(workflowItemId: number, groupId: string): Observable<ReliabilityBlockDiagram> {
        return this.api
            .getReliabilityBlockDiagram(workflowItemId, groupId)
            .pipe(map((resp: APIResponse<ReliabilityBlockDiagram>) => resp.response));
    }

    getFailureModes(workflowItemId: number, groupId: string): Observable<DataSource> {
        return this.api.getFailureModes(workflowItemId, groupId);
    }
}
